import { type EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { VoiceReadingHandler } from './services/handlers/voice-reading.handler';
import { DocumentAudioPlaybackProvider } from './services/providers/document-audio-playback.provider';
import { HttpSynthesisProvider } from './services/providers/http-synthesis.provider';
import {
  AUDIO_PLAYBACK_PROVIDER,
  SYNTHESIS_PROVIDER,
  VOICE_READING_HANDLER,
} from './tokens/chat.tokens';

/**
 * La voce non e' della chat: la conversazione la usa per leggere i messaggi, e le impostazioni per far
 * sentire com'e' la voce scelta prima di sceglierla. Vive quindi a livello di applicazione, come le
 * impostazioni del cittadino, e non sulla rotta della chat — montata li', la pagina delle impostazioni
 * non l'avrebbe, e sarebbe una seconda voce con un secondo altoparlante.
 */
export function provideVoiceReading(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: SYNTHESIS_PROVIDER, useClass: HttpSynthesisProvider },
    { provide: AUDIO_PLAYBACK_PROVIDER, useClass: DocumentAudioPlaybackProvider },
    { provide: VOICE_READING_HANDLER, useClass: VoiceReadingHandler },
  ]);
}
